export const Routes = {
	// INJECT_FROM_PLOP_TABLELIST
	PURCHASE_ORDER: '/purchase-orders',
	CUSTOMER_INVOICE: '/customer-invoices',
	SITE_DOCUMENT: '/site-documents',
	BACKUP_DOCUMENT: '/backup-documents',
	BIOHAZARDOUS_MANIFEST: '/biohazardous-manifests',
	WASTESTREAM: '/wastestreams',
	ORDER: '/orders',
	REPORT: '/reports',
	COMPANY_CATEGORIES: '/company-categories',
	ACCOUNT_CATEGORIES: '/account-categories',
	TREATMENT_CATEGORIES: '/treatment-categories',
	TREATMENT_METHODS: '/treatment-methods',
	DASHBOARD: '/',
	MANIFESTS: '/manifests',
	MOU: '/mou',
	HELP_CENTER: '/help-center',
	PROFILE: '/profile',
	REGISTRATION_DOCUMENT: '/registration-document',
	ANALYTIC: '/analytic',
	STORE_METRIC_BY_PERIODS: '/metric-by-periods',
	LOCATION: '/location',
	AUDIT: '/audit',
	SERVICE_LOCATION: '/service-location'
}
